export default __webpack_public_path__ + "static/media/ers.70cabb5d.png";